import axios from "axios"
export default class Request {
  constructor(config) {
    this.config = config
  }

  /**
   * @description 基础get方法
   * @author liupl
   * @date 2021-07-12
   * @param {object} params
   * @return {promise}
   * @memberof Request
   */
  async get(params) {
    return axios(
      Object.assign(
        {
          method: "GET",
          withCredentials: true
        },
        this.config,
        params
      )
    ).then(
      res => {
        return res.data
      },
      err => {
        return err?.response?.data
      }
    )
  }
  async post(params) {
    return axios(
      Object.assign(
        {
          method: "POST",
          withCredentials: true
        },
        this.config,
        params
      )
    ).then(res => {
      return Promise.resolve(res.data)
    })
  }
  async normalRespnseHandler(response) {
    if (response.code === 200 && response.success) {
      return response.data
    }
    return Promise.reject(response)
  }
}
